import styled from "styled-components";
import { constants, spacing, theme } from "../../../layout";
import { Body, Caption } from "../../../components/Typography";

export const Container = styled.div`
  border: 1px solid ${theme.border};
  border-radius: ${constants.radius.view}px;
  padding: 0px ${spacing.s}px;
`;

export const SubSection = styled.div`
  padding: 0px ${spacing.m}px;
`;

export const ValidatorCaption = styled(Caption)`
  margin-left: ${spacing.xs}px;
  line-height: 0.7em;
`;
